import { render, staticRenderFns } from "./AddWoundCourseModal.vue?vue&type=template&id=7e45bb51&"
import script from "./AddWoundCourseModal.vue?vue&type=script&lang=js&"
export * from "./AddWoundCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports